import React, {FC} from 'react';
import {Alert} from '@material-ui/lab';
import {Box, Typography} from '@material-ui/core';

import {getLocale} from 'epic-common';
import {Button} from '@epic-ui/components';

import useLocalization from '../../../../../hooks/useLocalization';
import {AlertSkeleton, ButtonSkeleton} from '../../../../common/skeleton';
import useStyles from './CalribrationStatus.styles';
import {XpCalibrationStatus} from '../../../../../types';

export interface CalibrationStatusProps {
    status: XpCalibrationStatus;
    isLoading: boolean;
}

const CODES = {
    title: 'epic.affiliate.fortnite_games.xp.calibration_status.title',
    calibrationMessage: 'epic.affiliate.fortnite_games.xp.calibration_status.',
    learnMore: 'epic.affiliate.fortnite_games.xp.calibration_status.learn_more'
};

const CalibrationStatus: FC<CalibrationStatusProps> = ({
    status,
    isLoading
}: CalibrationStatusProps) => {
    const locale = getLocale();
    const getMessage = useLocalization();
    const styles = useStyles();

    const docsUrl = `https://www.epicgames.com/fortnite/${locale}/creative/docs/games-xp-dashboard-in-fortnite-creative`;

    const actionButton = (
        <Button
            color="secondary"
            component="a"
            href={docsUrl}
            rel="noopener noreferrer"
            target="_blank"
            size="medium"
            className={styles.actionButton}>
            {getMessage(CODES.learnMore)}
        </Button>
    );

    return (
        <Box mt={8}>
            <Typography>{getMessage(CODES.title)}</Typography>

            {isLoading ? (
                <AlertSkeleton
                    AlertProps={{
                        action: <ButtonSkeleton className={styles.alertSkeletonButton} />,
                        severity: 'info',
                        className: styles.alertSkeleton
                    }}
                    SkeletonProps={{height: 40}}
                />
            ) : (
                <Alert
                    severity={
                        status === XpCalibrationStatus.DATA_ERROR
                            ? XpCalibrationStatus.ERROR
                            : status
                    }
                    variant="outlined"
                    action={actionButton}
                    className={styles.alert}>
                    <Typography
                        className={styles.alertMessage}
                        component="span"
                        color="textPrimary">
                        {getMessage(`${CODES.calibrationMessage}${status}`)}
                    </Typography>
                </Alert>
            )}
        </Box>
    );
};

export default CalibrationStatus;
